export type MentionResolver = (id: string) => string;

export function normalizeSlackToMarkdown(
  input: string,
  options?: { resolveMention?: MentionResolver },
): string {
  const resolveMention: MentionResolver =
    options?.resolveMention || ((id) => `@${id}`);

  let out = input || '';

  out = out.replace(/<((?:https?:\/\/)[^>|]+)\|([^>]+)>/gu, '[$2]($1)');

  out = out.replace(/<@([A-Z0-9]+)>/gu, (_m, id: string) => resolveMention(id));

  if (options?.resolveMention) {
    out = out.replace(
      /(^|\s)@([A-Za-z0-9_-]+)\b/gu,
      (_m, prefix: string, token: string) =>
        `${prefix}${resolveMention(token)}`,
    );
  }

  out = out.replace(/<#([A-Z0-9]+)\|([^>]+)>/gu, '#$2');

  out = out.replace(/<!([^>|]+)>/gu, (_m, word: string) => `@${word}`);
  out = out.replace(
    /<!([^>|]+)\|([^>]+)>/gu,
    (_m, _code: string, label: string) => `@${label}`,
  );

  out = out.replace(/^\s*•\s+/gmu, '- ');
  out = out.replace(/^\s*\*([^\n*]+)\*\s*$/gmu, '### $1');

  return out;
}
